import {createStore, compose, applyMiddleware} from 'redux';
import { allReducers } from './dataReducers';
import thunk from 'redux-thunk';
import { RunContextApp } from 'framework/RCApp';

export default function configureStore(rc : RunContextApp) {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(allReducers(rc), {},
    composeEnhancer(applyMiddleware(thunk)));
}
